<div class="d-flex align-items-center justify-content-end">
  <div class="preview">
    @if (preview) {
      <img
        [src]="getImageUrl(preview)"
        alt="File upload preview"
        />
    }
  </div>
  <img
    class="controll-btn"
    src="/static/images/upload.png"
    (click)="fileInput.click()"
    alt="upload"
    />@if (isDeletable) {
    <img
      class="controll-btn"
      src="/static/images/clear.png"
      alt="clear"
      (click)="clear()"
      />
  }
  <input #fileInput hidden="hidden" type="file" [accept]="accept" />
</div>
